module.exports = __webpack_public_path__ + "static/media/account_logo.a0fdbe8d.png";